export const collections = {
  reservations: "reservations",
  businesses: "businesses",
  accounts: "accounts",
  users: "users",
  regions: "regions",
  inviteUser: "inviteUser",
  shifts: "shifts"
};
